"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WireProtocolBase = exports.formatWireOrigin = void 0;
const formatWireOrigin = (origin) => origin === "core" ? "core" : `plugin "${origin.plugin}"`;
exports.formatWireOrigin = formatWireOrigin;
class WireProtocolBase {
    constructor(inboundChannels, outboundChannels) {
        this.inbound = new Map();
        this.outbound = new Map();
        for (const channel of inboundChannels) {
            this.inbound.set(channel, new Map());
        }
        for (const channel of outboundChannels) {
            this.outbound.set(channel, new Map());
        }
    }
    claimInbound(channel, creator, origin) {
        this.claim("inbound", this.inbound, channel, creator, origin);
    }
    claimOutbound(channel, creator, origin) {
        this.claim("outbound", this.outbound, channel, creator, origin);
    }
    acceptsInbound(channel, type) {
        var _a, _b;
        return (_b = (_a = this.inbound.get(channel)) === null || _a === void 0 ? void 0 : _a.has(type)) !== null && _b !== void 0 ? _b : false;
    }
    acceptsOutbound(channel, type) {
        var _a, _b;
        return (_b = (_a = this.outbound.get(channel)) === null || _a === void 0 ? void 0 : _a.has(type)) !== null && _b !== void 0 ? _b : false;
    }
    validateInbound(channel, type, payload) {
        return this.validate("inbound", this.inbound, channel, type, payload);
    }
    /** Drop every claim. Used when a registry changes and the protocol rebuilds. */
    clear() {
        for (const map of this.inbound.values()) {
            map.clear();
        }
        for (const map of this.outbound.values()) {
            map.clear();
        }
    }
    claim(direction, store, channel, creator, origin) {
        const channelMap = store.get(channel);
        if (!channelMap) {
            // eslint-disable-next-line no-console
            console.error(`[wire-protocol] unknown ${direction} channel: ${String(channel)}`);
            return;
        }
        const existing = channelMap.get(creator.type);
        if (existing) {
            const claimedBy = (0, exports.formatWireOrigin)(existing.origin);
            const duplicateFrom = (0, exports.formatWireOrigin)(origin);
            const ch = String(channel);
            // eslint-disable-next-line no-console
            console.error(`[wire-protocol] ${direction} channel "${ch}" type "${creator.type}" ` +
                `already claimed by ${claimedBy}; ignoring duplicate from ${duplicateFrom}`);
            return;
        }
        channelMap.set(creator.type, { creator, origin });
    }
    validate(direction, store, channel, type, payload) {
        var _a;
        const slot = (_a = store.get(channel)) === null || _a === void 0 ? void 0 : _a.get(type);
        if (!slot) {
            return {
                ok: false,
                reason: `unknown ${direction} type on channel "${String(channel)}": ${type}`,
            };
        }
        return validateAgainstSchema(slot.creator.schema, payload);
    }
}
exports.WireProtocolBase = WireProtocolBase;
const validateAgainstSchema = (schema, payload) => {
    if (!schema) {
        return { ok: true, payload };
    }
    const result = schema.safeParse(payload);
    if (result.success) {
        return { ok: true, payload: result.data };
    }
    return { ok: false, reason: result.error.message };
};
